import { DataServiceInterface } from '@/services/interface/DataService.js'
import { BackendDataService } from '@/services/impl/BackendDataService.js'
import { DemoDataService } from '@/services/impl/DemoDataService.js'

let service = BackendDataService

export function setupBackendDataService () {
  service = BackendDataService
}

export function setupDemoDataService () {
  service = DemoDataService
}

export class DataService extends DataServiceInterface {
  static async initialLoad (params) {
    return service.initialLoad(params)
  }

  static async getMessages (params) {
    return service.getMessages(params)
  }

  static async getEconomicEfficiency (params) {
    return service.getEconomicEfficiency(params)
  }

  static async getTendersCount (params) {
    return service.getTendersCount(params)
  }

  static async getTendersSum (params) {
    return service.getTendersSum(params)
  }

  static async getOffersCount (params) {
    return service.getOffersCount(params)
  }

  static async getTendersAvgTimeSpending (params) {
    return service.getTendersAvgTimeSpending(params)
  }

  static async getTendersAvgTimeDuration (params) {
    return service.getTendersAvgTimeDuration(params)
  }

  static async getCountCompaniesInvitedByOrg (params) {
    return service.getCountCompaniesInvitedByOrg(params)
  }

  static async getCountCompaniesInvitedByTpro (params) {
    return service.getCountCompaniesInvitedByTpro(params)
  }

  static async getProvidersTop10 (params) {
    return service.getProvidersTop10(params)
  }

  static async getCriticalIndicators (params) {
    return service.getCriticalIndicators(params)
  }

  static async getClaims (params) {
    return service.getClaims(params)
  }

  static async getClaimsStats (params) {
    return service.getClaimsStats(params)
  }

  static async getClaimDetails (params) {
    return service.getClaimDetails(params)
  }

  static async getProcedures (params) {
    return service.getProcedures(params)
  }

  static async getProceduresStats (params) {
    return service.getProceduresStats(params)
  }

  static async getProcedureDetails (params) {
    return service.getProcedureDetails(params)
  }

  static async getProcedureLite (params) {
    return service.getProcedureLite(params)
  }

  static async getProcedureWinners (params) {
    return service.getProcedureWinners(params)
  }

  static async createContract (params) {
    return service.createContract(params)
  }

  static async getContractState (params) {
    return service.getContractState(params)
  }

  static async updateContractState (params) {
    return service.updateContractState(params)
  }

  static async getReference (params) {
    return service.getReference(params)
  }

  static async getContracts (params) {
    return service.getContracts(params)
  }

  static async getContractStatuses (params) {
    return service.getContractStatuses(params)
  }

  static async getContractLogs (params) {
    return service.getContractLogs(params)
  }

  static async getContractLogsStats (params) {
    return service.getContractLogsStats(params)
  }

  static async getContractStats (params) {
    return service.getContractStats(params)
  }

  static async getContractPositions (params) {
    return service.getContractPositions(params)
  }

  static async importContractPositions (params) {
    return service.importContractPositions(params)
  }

  static async appendTenderWinnerPositions (params) {
    return service.appendTenderWinnerPositions(params)
  }

  static async removeContractPositions (params) {
    return service.removeContractPositions(params)
  }

  static async createContractPosition (params) {
    return service.createContractPosition(params)
  }

  static async updateContractPosition (params) {
    return service.updateContractPosition(params)
  }

  static async createOrder (params) {
    return service.createOrder(params)
  }

  static async getOrders (params) {
    return service.getOrders(params)
  }

  static async getOrderStatuses (params) {
    return service.getOrderStatuses(params)
  }

  static async getOrderStats (params) {
    return service.getOrderStats(params)
  }

  static async getOrderState (params) {
    return service.getOrderState(params)
  }

  static async getOrderPositions (params) {
    return service.getOrderPositions(params)
  }

  static async appendContractPositions (params) {
    return service.appendContractPositions(params)
  }

  static async removeOrderPositions (params) {
    return service.removeOrderPositions(params)
  }

  static async deleteOrderPosition (params) {
    return service.deleteOrderPosition(params)
  }

  static async createOrderPosition (params) {
    return service.createOrderPosition(params)
  }

  static async updateOrderPosition (params) {
    return service.updateOrderPosition(params)
  }

  static async updateOrderState (params) {
    return service.updateOrderState(params)
  }

  static async getOrderLogs (params) {
    return service.getOrderLogs(params)
  }

  static async getOrderLogsStats (params) {
    return service.getOrderLogsStats(params)
  }

  static async getCompanies (params) {
    return service.getCompanies(params)
  }

  static async getManagers (params) {
    return service.getManagers(params)
  }

  static async getDepartments (params) {
    return service.getDepartments(params)
  }

  static async getUsers (params) {
    return service.getUsers(params)
  }

  static async getProducts (params) {
    return service.getProducts(params)
  }

  static async getUnits (params) {
    return service.getUnits(params)
  }

  static async getCurrencies (params) {
    return service.getCurrencies(params)
  }

  static async getCrossEntitiesRelations (params) {
    return service.getCrossEntitiesRelations(params)
  }

  static async generateReport (params) {
    return service.generateReport(params)
  }

  static async getDocumentTemplates (params) {
    return service.getDocumentTemplates(params)
  }

  static async loadDocumentTemplate (params) {
    return service.loadDocumentTemplate(params)
  }

  static async createDocumentTemplate (params) {
    return service.createDocumentTemplate(params)
  }

  static async updateDocumentTemplate (params) {
    return service.updateDocumentTemplate(params)
  }

  static async createDocument (params) {
    return service.createDocument(params)
  }

  static async updateDocument (params) {
    return service.updateDocument(params)
  }

  static async getDocuments (params) {
    return service.getDocuments(params)
  }

  static async renderDocument (params) {
    return service.renderDocument(params)
  }

  static async deleteDocuments (params) {
    return service.deleteDocuments(params)
  }

  static async getCompanyInfo (params) {
    return service.getCompanyInfo(params)
  }

  static async getUserInfo (params) {
    return service.getUserInfo(params)
  }

  static async emailTemplate (params) {
    return service.emailTemplate(params)
  }

  static async sendEmail (params) {
    return service.sendEmail(params)
  }

  static async fileTemplate (params) {
    return service.fileTemplate(params)
  }
}
